/**
 * ULD 复称清单 OCR 解析 API
 */

import apiClient from "./axios";

export const uldOcrApi = {
    /**
     * 上传 PDF/图片文件并触发解析
     * @param {File|File[]} files - PDF 或图片文件（单个或多个）
     * @returns {Promise} API 响应
     */
    parse: (files) => {
        const formData = new FormData();
        
        // 支持单文件（兼容）或多文件
        if (Array.isArray(files)) {
            files.forEach(file => {
                formData.append("files", file);
            });
        } else {
            formData.append("files", files);
        }

        return apiClient.post("/v1/uld-ocr/parse", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },

    /**
     * 获取解析历史列表
     * @param {number|Object} pageOrParams - 页码 或 参数对象 {page, page_size, status}
     * @param {number} page_size - 每页数量（当第一个参数是数字时使用）
     * @param {Object} options - 额外选项 {silent}
     * @returns {Promise} API 响应
     */
    getHistory: (pageOrParams = 1, page_size = 20, options = {}) => {
        let params;
        let silent = false;
        
        // 兼容两种调用方式
        if (typeof pageOrParams === 'object') {
            // 对象参数方式: getHistory({page, page_size, status})
            params = { ...pageOrParams };
            silent = pageOrParams.silent || false;
        } else {
            // 分离参数方式: getHistory(page, page_size, {silent})
            params = { page: pageOrParams, page_size };
            silent = options.silent || false;
        }
        
        const config = { params };
        // 静默模式：不显示全局错误提示（用于轮询场景）
        if (silent) {
            config._silentError = true;
        }
        
        return apiClient.get("/v1/uld-ocr/history", config);
    },

    /**
     * 获取单条解析历史详情
     * @param {number} id - 记录 ID
     * @returns {Promise} API 响应
     */
    getHistoryDetail: (id) => {
        return apiClient.get(`/v1/uld-ocr/history/${id}`);
    },

    /**
     * 保存人工修改过的识别结果，并重新生成 Excel
     * @param {number} id - 记录 ID
     * @param {Object} data - { flight_number, flight_date, result_data }
     * @returns {Promise} API 响应
     */
    updateHistory: (id, data) => {
        return apiClient.put(`/v1/uld-ocr/history/${id}`, data);
    },
};

export default uldOcrApi;
